import { useState, useEffect } from 'react';
import Bubble from '@/components/bubble';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';

function MoreInfoText({ className, text, moreInfo }) {
  const [isShown, setIsShown] = useState(false);
  const handleOnMouseEnter = () => {
    setIsShown(true);
  };
  const handleOnMouseLeave = () => {
    setIsShown(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsShown(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className={className}>
      <div
        tabIndex="0"
        onFocus={handleOnMouseEnter}
        onBlur={handleOnMouseLeave}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
        className="more-info-text-container"
      >
        <TextInfo
          text={text}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.BLUEA}
          size={TEXT_SIZE.CAPTION2}
        />
        {isShown && (
          <div className="more-info-text-bubble">
            <Bubble
              textBubble={moreInfo}
              cyData="lm-form-bubble-error"
              showIcon={false}
            />
          </div>
        )}
      </div>

      <style jsx>
        {`
          .more-info-text-container {
            position: relative;
          }
          .more-info-text-bubble {
            width: 280px;
            position: absolute;
            left: -90px;
            bottom: 28px;
          }
        `}
      </style>
    </div>
  );
}
export default MoreInfoText;
